<template>
  <div>
    <div class="row">
      <div class="col-12 card" style="overflow-x: scroll">
                <Table 

                    :headers="headers"
                    :cols="cols"
                    :data="contacts"
                    :checkbox="false"
                    :notselect="true"
                    :model="contacts">
                </Table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Table from "@/components/Common/Table.vue";

export default {
  data() {
    return {
        cols:[
            [{
                value: "name",
                link: "linkedin_url",
                type: "link",
                class: "cursor-pointer",
                icons: [
                  {
                    icon_if: "linkedin_url",
                    icon_true: "icon-linkedin text-primary",
                  },
                ],
              tooltip: "name",
              },
            ],
            [{
            'value' : 'title',
              tooltip: "title",
            }],
            [{
            'value' : 'organization',
            'value2' : 'name'
            }],
            [{
            'value' : 'city'
            }],
            [{
            'value' : 'country'
            }]
        ],
        headers:[
            {
              label : this.$t('lang.label.name'),
              percentage:'20%',
              class:'overflowhide',
              size: "150px",
            },
            {
              label : this.$t('lang.column.jobtitle'),
              percentage:'20%',
              class:'overflowhide',
              size: "150px",
            },
            {
              label : this.$t('lang.column.company'),
              percentage:'20%',
              class:'overflowhide',
              size: "150px"
            },
            {
              label : this.$t('lang.column.city'),
              percentage:'20%',
              class:'overflowhide',
              size: "150px"
            },
            {
              label : this.$t('lang.column.country'),
              percentage:'20%',
              class:'overflowhide',
              size: "150px"
            }
        ]
    }
  },
  components:{
    Table
  },
  props: {
    contacts: {},
  },
};
</script>

<style  scoped>
table {
  border-spacing: 1em .5em;
  padding: 0 2em 1em 0;
}
table  td{
  padding: 0 4em 1em 0;
  left:150px;
}
.bold-text{
  color: #2f34e6;;
  font-weight: bold;
}
</style>
